import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useUpdateBuyOrder } from 'services/buy-process';
import { useBuyProcessForm } from '../../buy-process-form-utils';
import { RootState } from '../../../../global';
import { saveEditClientInfo } from '../../../admin/buy-process/buy-order-edit/buy-order-edit-redux';
import {
  onGoBackInForm,
  onGoForwardInForm,
  useSaveBuyOrderFormState,
} from '../../use-buy-process-form';
import { useIsAdminOnBuyOrderEditForm } from '../../../../utils/buy-order/use-is-admin-on-buy-order-edit-form';
import { selectBuyClientInfoPersonFactory } from '../../../../services/buy-process/selectors';
import { validationSchema } from './client-info-utils';
import { ClientInfoFormState } from './client-info-types';

export const useClientInfo = () => {
  const { id, setRequestedStep } = useBuyProcessForm();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { person, ...initialState } = useSelector(
    (state: RootState) => state.buyOrderEdit[id].clientInfo,
  );

  const personState = useSelector(selectBuyClientInfoPersonFactory(id));

  const { trigger, handleSubmit, getValues, setError, errors, ...rest } = useForm<ClientInfoFormState>({
    mode: 'onBlur',
    resolver: yupResolver(validationSchema),
    defaultValues: { ...initialState, ...personState },
  });

  useSaveBuyOrderFormState(saveEditClientInfo, getValues(), trigger);

  const dispatch = useDispatch();
  const isAdmin = useIsAdminOnBuyOrderEditForm();
  const [updateBuyOrder, updateBuyOrderMeta] = useUpdateBuyOrder(id);

  return {
    isUpdating: updateBuyOrderMeta.isLoading,
    onSubmit: handleSubmit((data) => {
      dispatch(saveEditClientInfo({ ...data, id }));
      updateBuyOrder();

      if (!isAdmin) {
        setRequestedStep((s) => s + 1);
      }
    }),
    onForward: (e: React.MouseEvent<HTMLButtonElement>) =>
      onGoForwardInForm(setRequestedStep, e),
    onBack: (e: React.MouseEvent<HTMLButtonElement>) =>
      onGoBackInForm(setRequestedStep, trigger, e),
    setError,
    errors,
    id,
    ...rest,
  };
};
